import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex w-full flex-col items-center gap-2 text-center" };
const _hoisted_2 = { class: "flex flex-col items-center gap-0.5" };
const _hoisted_3 = ["id"];
const _hoisted_4 = { class: "text-base leading-6 text-(--colors-text-black-default)" };
const _hoisted_5 = { class: "flex flex-col gap-8" };
const _hoisted_6 = { class: "flex w-[314px] flex-col gap-px" };
const _hoisted_7 = ["for"];
const _hoisted_8 = { class: "text-sm font-medium leading-5 text-(--colors-text-black-default)" };
const _hoisted_9 = ["id", "aria-invalid", "aria-describedby", "placeholder", "onKeydown"];
const _hoisted_10 = ["id"];
import { ref, useId, watch } from "vue";
import { Modal, Button, IconShape } from "@eudonet/opal";
import { useFilterNameField } from "@/shared/composables/useFilterNameField";
import FilterSharingFields from "@/shared/components/advanced-filter-library/FilterSharingFields.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SaveAdvancedFilterModal',
    props: {
        modelValue: { type: Boolean },
        busy: { type: Boolean, default: false },
        errorMessage: { default: null }
    },
    emits: ["update:modelValue", "save"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const titleId = useId();
        const nameId = useId();
        const errorId = useId();
        const { name, shownError, validate } = useFilterNameField({
            isOpen: () => props.modelValue,
            errorMessage: () => props.errorMessage,
            requiredKey: "advancedFilterLibrary.save.errors.nameRequired",
            tooLongKey: "advancedFilterLibrary.save.errors.nameTooLong",
        });
        const personalSharing = () => ({ destination: "personal", access: { organization: null, users: [] } });
        const sharing = ref(personalSharing());
        watch(() => props.modelValue, (open) => {
            if (open)
                sharing.value = personalSharing();
        });
        function onSubmit() {
            const trimmed = validate();
            if (trimmed)
                emit("save", trimmed, sharing.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                "model-value": props.modelValue,
                size: "md",
                "footer-position": "split",
                "overlay-class": "!z-[300]",
                "aria-labelledby": _unref(titleId),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (emit('update:modelValue', $event)))
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(IconShape), {
                            size: "lg",
                            type: "square",
                            variant: "outlined",
                            color: "white",
                            icon: "ri-shuffle-line"
                        }),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("h4", {
                                id: _unref(titleId),
                                class: "text-xl font-bold leading-6 text-(--colors-text-heading)"
                            }, _toDisplayString(_ctx.$t("advancedFilterLibrary.save.title")), 9 /* TEXT, PROPS */, _hoisted_3),
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("advancedFilterLibrary.save.subtitle")), 1 /* TEXT */)
                        ])
                    ])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _ctx.$t('advancedFilterLibrary.save.cancel'),
                        disabled: props.busy,
                        onClick: _cache[2] || (_cache[2] = ($event) => (emit('update:modelValue', false)))
                    }, null, 8 /* PROPS */, ["label", "disabled"]),
                    _createVNode(_unref(Button), {
                        "data-testid": "save-filter-submit",
                        variant: "primary",
                        "icon-left": "ri-save-3-fill",
                        label: _ctx.$t('advancedFilterLibrary.save.submit'),
                        loading: props.busy,
                        disabled: props.busy,
                        onClick: onSubmit
                    }, null, 8 /* PROPS */, ["label", "loading", "disabled"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("label", {
                                for: _unref(nameId),
                                class: "flex items-center gap-0 px-px"
                            }, [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("advancedFilterLibrary.save.nameLabel")), 1 /* TEXT */),
                                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-sm font-medium leading-5 text-(--colors-text-black-default)" }, "*", -1 /* CACHED */))
                            ], 8 /* PROPS */, _hoisted_7),
                            _withDirectives(_createElementVNode("input", {
                                id: _unref(nameId),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(name) ? (name).value = $event : null)),
                                "data-testid": "save-filter-name",
                                type: "text",
                                "aria-required": "true",
                                "aria-invalid": !!_unref(shownError),
                                "aria-describedby": _unref(shownError) ? _unref(errorId) : undefined,
                                placeholder: _ctx.$t('advancedFilterLibrary.save.namePlaceholder'),
                                class: "w-full rounded-xl border border-(--colors-border-base-medium) bg-(--colors-background-white) px-3 py-2 text-sm leading-5 text-(--colors-text-black-default) placeholder:text-(--text-text-disabled-strong)",
                                onKeydown: _withKeys(_withModifiers(onSubmit, ["prevent"]), ["enter"])
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9), [
                                [_vModelText, _unref(name)]
                            ]),
                            (_unref(shownError))
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    id: _unref(errorId),
                                    "data-testid": "save-filter-name-error",
                                    role: "alert",
                                    class: "px-px pt-1 text-sm leading-5 text-(--text-text-error-strong)"
                                }, _toDisplayString(_unref(shownError)), 9 /* TEXT, PROPS */, _hoisted_10))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createVNode(FilterSharingFields, {
                            modelValue: sharing.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((sharing).value = $event)),
                            disabled: props.busy
                        }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value", "aria-labelledby"]));
        };
    }
});
